import React, {memo, useState, useCallback} from 'react';
import {connect} from 'react-redux';
import StepData from 'pattern/StepData.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {DEFAULT_HEIGHT} from './constants.js';

const NoteSidePanelRow = memo((props) => {
    const [triggering, setTriggering] = useState(false);

    let height = DEFAULT_HEIGHT * props.scale;
    var style = {
        height: height,
    };

    var noteStyle = {};
    
    let noteSideInfoClass = 
        props.note.note === 'C' ?
        'note-side-info note-c' : 'note-side-info';
    let noteClassName =  'note-blank-side';
    let noteNameStyle = {};
    
    let noteNameClassName = props.note.isBlackNote() ? "black-note note-name" : "white-note note-name";
    
    if (triggering || props.isTriggering) {
        noteSideInfoClass += ' triggering';
        noteStyle.backgroundColor = props.color;
        if (!props.note.isBlackNote()) {
            noteNameStyle.backgroundColor = props.color;
        }
    }

    const onMouseLeave = useCallback((e) => {
        if (triggering) {
            props.track.midiEffects.liveInputRelease(
                props.note.getTranspose(),
                0);
            setTriggering(false);
        }
    }, [setTriggering, props.note, props.track]);

    const triggerAttack = useCallback((e) => {
        e.stopPropagation();
        let track = props.track;
        let stepData = new StepData();
        stepData.copyFrom(track.trackData);
        stepData.transpose = props.note.getTranspose();
        stepData.slice = 0;
        stepData.duration = null;
        track.midiEffects.liveInputTrigger(stepData);
        setTriggering(true);
    }, [setTriggering, props.note, props.track]);

    const triggerRelease = useCallback((e) => {
        e.stopPropagation();
        props.track.midiEffects.liveInputRelease(
            props.note.getTranspose(),
            0);
        setTriggering(false);
    }, [setTriggering, props.note, props.track]);

    return (
        <div
          style={style}
          draggable={false}
          onMouseOver={() => props.onMouseOver(props.note)}
          onMouseDown={triggerAttack}
          onMouseUp={triggerRelease}
          className={noteSideInfoClass}>
         <div
            style={noteStyle}
            className={noteNameClassName}>
          </div>
          <div
            style={noteNameStyle}
            className={noteClassName}>
            <ConditionedComponent condition={props.note.note === 'C'}>
              {props.note.toString()}
            </ConditionedComponent>
          </div>
        </div>
    );
});


export default NoteSidePanelRow;
